/**
 * Loại thu phí lệ phí
 */
export default {
  All: 0, // Tất cả
  Fee: 1, // Phí
  ChargeFee: 2, // Lệ phí
};
